import { Popover as PopoverA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { resolveClassNames } from '../utils';

type P = {
  size?: 'small';
  stretch?: boolean;
} & ComponentProps<typeof PopoverA>;

const Popover = ({ className, classNames, size, stretch, ...rest }: P) => (
  <PopoverA
    className={cn('ui-popover-trigger', { 'ui-popover-trigger--stretch': stretch }, className)}
    classNames={resolveClassNames(classNames, (resolvedClassNames) => ({
      ...resolvedClassNames,
      root: cn('ui-popover', { 'ui-popover--small': size }, resolvedClassNames?.root),
    }))}
    {...rest}
  />
);

export default Popover;
